
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import 'toastr/build/toastr.min.css';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import homeh9hud from './pages/homeh9hud/homeh9hud'
import postulark7twck from './pages/postulark7twck/postulark7twck'
import registorexitoso06z24h from './pages/registorexitoso06z24h/registorexitoso06z24h'
import chambaindexbkicl from './pages/chambaindexbkicl/chambaindexbkicl'
import chambatalks5cqjg from './pages/chambatalks5cqjg/chambatalks5cqjg'
import fundacinqc8wmk from './pages/fundacinqc8wmk/fundacinqc8wmk'
import sobrenosotrosekrzx from './pages/sobrenosotrosekrzx/sobrenosotrosekrzx'
import chambometroelectoralfz8nx from './pages/chambometroelectoralfz8nx/chambometroelectoralfz8nx'
import chambeadordelao9t1fw from './pages/chambeadordelao9t1fw/chambeadordelao9t1fw'
import contactofwrl5h from './pages/contactofwrl5h/contactofwrl5h'
import chambanomicsrfr4h from './pages/chambanomicsrfr4h/chambanomicsrfr4h'
import contacto3341a from './pages/contacto3341a/contacto3341a'
import exitosoenindex1m5zqf from './pages/exitosoenindex1m5zqf/exitosoenindex1m5zqf'
import exitosodetalksupbja from './pages/exitosodetalksupbja/exitosodetalksupbja'
import exitosochambometroygrit from './pages/exitosochambometroygrit/exitosochambometroygrit'
import eventopj0yh from './pages/eventopj0yh/eventopj0yh'
import muyprontoqw8qk from './pages/muyprontoqw8qk/muyprontoqw8qk'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={homeh9hud} />
			<Route exact path="/agregarcv2" component={postulark7twck} />
			<Route exact path="/exitoso" component={registorexitoso06z24h} />
			<Route exact path="/index" component={chambaindexbkicl} />
			<Route exact path="/talks" component={chambatalks5cqjg} />
			<Route exact path="/fundacion" component={fundacinqc8wmk} />
			<Route exact path="/sobrenosotros" component={sobrenosotrosekrzx} />
			<Route exact path="/chambometro" component={chambometroelectoralfz8nx} />
			<Route exact path="/chambeador" component={chambeadordelao9t1fw} />
			<Route exact path="/agregarcv" component={contactofwrl5h} />
			<Route exact path="/chambanomics" component={chambanomicsrfr4h} />
			<Route exact path="/contacto" component={contacto3341a} />
			<Route exact path="/exitoso/index" component={exitosoenindex1m5zqf} />
			<Route exact path="/exitoso/talks" component={exitosodetalksupbja} />
			<Route exact path="/exitoso/chambometro" component={exitosochambometroygrit} />
			<Route exact path="/evento" component={eventopj0yh} />
			<Route exact path="*" component={muyprontoqw8qk} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

